import styled from 'styled-components';
import { Box } from '@zion-tech/ds-web';

export const Container = styled(Box)``;
